import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-6172">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-6173">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-6174">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-6175">
            <ArrowLeft className="w-4 h-4" data-id="element-6176" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-6177">NOIZA</div>
          <div className="w-20" data-id="element-6178" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-6179">
        <div className="mb-12" data-id="element-6180">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-6181">
            <FileText className="w-6 h-6 text-white/80" data-id="element-6182" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-6183">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-6184">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-6185">
          <section data-id="element-6186">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6187">
              <span className="text-[#006847]" data-id="element-6188">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6189">
              <p data-id="element-6190">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-6191">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6192">
                <li data-id="element-6193">Haber leído íntegramente este documento</li>
                <li data-id="element-6194">Comprender su contenido en su totalidad</li>
                <li data-id="element-6195">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-6196">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-6197">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6198">
              <span className="text-[#006847]" data-id="element-6199">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6200">
              <p data-id="element-6201">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6202">
                <li data-id="element-6203">Software como servicio (SaaS)</li>
                <li data-id="element-6204">Marketplace digital gastronómico</li>
                <li data-id="element-6205">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-6206">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6207">
                <li data-id="element-6208">Mostrar su menú digital</li>
                <li data-id="element-6209">Recibir pedidos de clientes</li>
                <li data-id="element-6210">Gestionar su operación interna</li>
                <li data-id="element-6211">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-6212">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-6213">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6214">
              <span className="text-[#006847]" data-id="element-6215">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6216">
              <p data-id="element-6217">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6218">
                <li data-id="element-6219">No es proveedor de alimentos</li>
                <li data-id="element-6220">No participa en la preparación de productos</li>
                <li data-id="element-6221">No manipula alimentos en ningún momento</li>
                <li data-id="element-6222">No realiza entregas ni logística</li>
                <li data-id="element-6223">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-6224">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-6225">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-6226">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6227">
              <span className="text-[#006847]" data-id="element-6228">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-6229">
              <p data-id="element-6230">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-6231">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6232">
                <li data-id="element-6233">El restaurante es el único responsable de su operación</li>
                <li data-id="element-6234">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-6235">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-6236">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6237">
                <li data-id="element-6238">Precios</li>
                <li data-id="element-6239">Menú</li>
                <li data-id="element-6240">Horarios</li>
                <li data-id="element-6241">Métodos de pago</li>
                <li data-id="element-6242">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6243">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6244">
              <span className="text-[#006847]" data-id="element-6245">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-6246">
              <div data-id="element-6247">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6248">
                  5.1. Alcance general
                </h3>
                <p data-id="element-6249">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-6250">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6251">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-6252">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6253">
                  <li data-id="element-6254">Calidad de los alimentos</li>
                  <li data-id="element-6255">Estado, frescura o preparación</li>
                  <li data-id="element-6256">Ingredientes utilizados</li>
                  <li data-id="element-6257">Contaminación cruzada</li>
                  <li data-id="element-6258">Problemas de higiene o salubridad</li>
                  <li data-id="element-6259">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6260">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-6261">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6262">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-6263">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6264">
                  <li data-id="element-6265">Retrasos en la entrega</li>
                  <li data-id="element-6266">Pérdida de pedidos</li>
                  <li data-id="element-6267">Entregas incompletas</li>
                  <li data-id="element-6268">Errores en dirección</li>
                  <li data-id="element-6269">Conducta de repartidores</li>
                  <li data-id="element-6270">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-6271">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6272">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-6273">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-6274">
                  <li data-id="element-6275">Recepción de pagos</li>
                  <li data-id="element-6276">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-6277">Manejo de efectivo</li>
                  <li data-id="element-6278">Confirmación de pagos</li>
                  <li data-id="element-6279">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-6280">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6281">
                  <li data-id="element-6282">Pagos no recibidos</li>
                  <li data-id="element-6283">Comprobantes falsos</li>
                  <li data-id="element-6284">Errores en montos</li>
                  <li data-id="element-6285">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-6286">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-6287">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-6288">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-6289">
                  <li data-id="element-6290">Reclamos de clientes</li>
                  <li data-id="element-6291">Reembolsos</li>
                  <li data-id="element-6292">Cancelaciones</li>
                  <li data-id="element-6293">Disputas</li>
                  <li data-id="element-6294">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-6295">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-6296">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6297">
              <span className="text-[#006847]" data-id="element-6298">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-6299">
              <p data-id="element-6300">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6301">
                <li data-id="element-6302">Responsable</li>
                <li data-id="element-6303">Legal</li>
                <li data-id="element-6304">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-6305">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6306">
                <li data-id="element-6307">Publicar información falsa</li>
                <li data-id="element-6308">Manipular precios de forma engañosa</li>
                <li data-id="element-6309">Simular disponibilidad inexistente</li>
                <li data-id="element-6310">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6311">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6312">
              <span className="text-[#006847]" data-id="element-6313">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-6314">
              <p data-id="element-6315">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6316">
                <li data-id="element-6317">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-6318">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-6319">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-6320">
                <li data-id="element-6321">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-6322">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-6323">
                    <li data-id="element-6324">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-6325">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-6326">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6327">
              <span className="text-[#006847]" data-id="element-6328">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-6329">
              <p data-id="element-6330">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6331">
                <li data-id="element-6332">Menú digital</li>
                <li data-id="element-6333">Gestión de pedidos</li>
                <li data-id="element-6334">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-6335">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6336">
                  <p className="font-medium text-white mb-2" data-id="element-6337">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6338">
                    <li data-id="element-6339">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-6340">
                  <p className="font-medium text-white mb-2" data-id="element-6341">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6342">
                    <li data-id="element-6343">Propiedad del software</li>
                    <li data-id="element-6344">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-6345">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-6346">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6347">
              <span className="text-[#006847]" data-id="element-6348">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-6349">
              <p data-id="element-6350">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6351">
                <li data-id="element-6352">Disponibilidad continua</li>
                <li data-id="element-6353">Funcionamiento sin interrupciones</li>
                <li data-id="element-6354">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-6355">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6356">
                <li data-id="element-6357">Fallas técnicas</li>
                <li data-id="element-6358">Actualizaciones</li>
                <li data-id="element-6359">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-6360">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-6361">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6362">
              <span className="text-[#006847]" data-id="element-6363">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-6364">
              <p data-id="element-6365">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6366">
                <li data-id="element-6367">No está garantizada permanentemente</li>
                <li data-id="element-6368">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-6369">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6370">
                <li data-id="element-6371">Destacar o no restaurantes</li>
                <li data-id="element-6372">Modificar posiciones</li>
                <li data-id="element-6373">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6374">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6375">
              <span className="text-[#006847]" data-id="element-6376">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-6377">
              <p data-id="element-6378">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6379">
                <li data-id="element-6380">Cumplir con los pagos acordados</li>
                <li data-id="element-6381">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-6382">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6383">
                <li data-id="element-6384">Suspender el servicio</li>
                <li data-id="element-6385">Limitar funcionalidades</li>
                <li data-id="element-6386">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6387">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6388">
              <span className="text-[#006847]" data-id="element-6389">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-6390">
              <p data-id="element-6391">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6392">
                <li data-id="element-6393">Incumplimiento de términos</li>
                <li data-id="element-6394">Uso indebido</li>
                <li data-id="element-6395">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-6396">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-6397">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6398">
              <span className="text-[#006847]" data-id="element-6399">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-6400">
              <p data-id="element-6401">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-6402">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-6403">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6404">
              <span className="text-[#006847]" data-id="element-6405">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-6406">
              <p data-id="element-6407">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-6408">
                <li data-id="element-6409">Pérdidas económicas</li>
                <li data-id="element-6410">Daños indirectos</li>
                <li data-id="element-6411">Lucro cesante</li>
                <li data-id="element-6412">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-6413">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6414">
              <span className="text-[#006847]" data-id="element-6415">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-6416">
              <p data-id="element-6417">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-6418">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-6419">
              <span className="text-[#006847]" data-id="element-6420">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-6421">
              <p className="font-medium" data-id="element-6422">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-6423">
                <li data-id="element-6424">Ha leído este documento completo</li>
                <li data-id="element-6425">Comprende su alcance</li>
                <li data-id="element-6426">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}